import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { _ } from '/@/locale';
import RVsDashboardCard from '../../../components/dashboard-cards/rvs-dashboard-card';
import RVsStatsDashboardCard from '../../../components/dashboard-cards/rvs-stats-dashboard-card';
import NewFieldGrowersModal from '../../../growers/components/new-field-modal';

const ActivitySection = ({ userNodeId }: { userNodeId?: number }) => {
    const [newFieldModalOpen, setNewFieldModalOpen] = useState(false);
    return (
        <Stack spacing={3}>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {_('Actividad de tus RVs')}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_('Accedé a la actividad de cada Representante de Ventas')}
                </Typography>
            </Stack>
            {userNodeId ? (
                <Stack spacing={2} height='100%'>
                    <Box>
                        <RVsDashboardCard userNodeId={userNodeId} />
                    </Box>
                    <Box>
                        <RVsStatsDashboardCard userNodeId={userNodeId} />
                    </Box>
                </Stack>
            ) : (
                <Skeleton variant='rectangular' height='500px' width='100%' />
            )}
            <NewFieldGrowersModal
                open={newFieldModalOpen}
                setOpen={setNewFieldModalOpen}
                rvUserNodeId={userNodeId}
                trackEntrySource='growers-list-dashboard'
            />
        </Stack>
    );
};

export default ActivitySection;
